import Phaser from 'phaser'
import KnollhurstMovement from './scenes/knollhurstMovement'

export function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    width: Math.min(window.innerWidth, 1920),
    height: Math.min(document.body.clientHeight - 82, 1080),

    backgroundColor: '#000000',
    parent: containerId,
    forceSetTimeOut: true,
    roundPixels: false,
    pixelArt: true,
    physics: {
      default: 'matter',
      matter: {
        gravity: {
          y: 0,
          x: 0,
        }
      }
    },
    scene: KnollhurstMovement
  })
}